export default __webpack_public_path__ + "static/heading_talents-3a7fd00e60c2b72c5e13102e30f8694c.svg";